import React from 'react';
import PropTypes from 'prop-types';
import s from '../../../../screens/staking/card-table/items/item.module.scss';
import ColumnStatusTitle from './title';
import cn from 'classnames';
import theme from '../../../../theme';
import { getDuration } from '../../../util';
import { useGetTheme } from '../../../../hooks/useGetTheme';

const ColumnStatus = ({ stakeDuration, stakeTime }) => {
  const colors = useGetTheme();

  return (
    <>
      <ColumnStatusTitle isMobile />
      <div className={cn(s.col, s.colColumn)}>
        <span className={s.topLine} style={{ color: theme.palette.mantra.pink, fontSize: '18px' }}>
          {stakeDuration > 0 ? 'Staking' : '—'}
        </span>
        {stakeTime ? (
          <div className={s.bottomLine}>
            <span style={{ color: colors.text }}>total:</span>
            <span style={{ color: theme.palette.mantra.pink }}>
              &nbsp;{getDuration(stakeTime)}&nbsp;
            </span>
            <span style={{ color: colors.text }}>days</span>
          </div>
        ) : null}
      </div>
    </>
  );
};

ColumnStatus.propTypes = {
  stakeDuration: PropTypes.string.isRequired,
  stakeTime: PropTypes.string,
};

export default ColumnStatus;
